import { render, staticRenderFns } from "./FulfillmentSummary.vue?vue&type=template&id=4da0c606&scoped=true"
import script from "./FulfillmentSummary.vue?vue&type=script&lang=js"
export * from "./FulfillmentSummary.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentSummary.vue?vue&type=style&index=0&id=4da0c606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0c606",
  null
  
)

export default component.exports